import React from "react";
import { Tabs } from "antd";
import TabPanes from "../../../../../../CommonComponents/TabsComponent/TabPanes";
import {
  DashboardTab,
  TabContainer
} from "../../../../../../CommonComponents/TabsComponent/styles";
import {
  WhiteGradient,
  NoData
} from "../../../../../../CommonComponents/commonStyles";
import { initiateTracking } from "../../../../../../utils/commonUtil";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";
import PropTypes from 'prop-types';

const TabPane = Tabs.TabPane;

let tabSelected;
let selectedTabvalue;
export function selectedTabs(e) {
  tabSelected = "";
  switch (e) {
    case "1":
      tabSelected = "Recent Exchanges";
      break;
    case "2":
      tabSelected = "Exchange Schedule";
      break;
  }
  selectedTabvalue = e;
  return tabSelected;
}
export function tabsHandler(e) {
  if (selectedTabvalue !== e) {
    initiateTracking("tabClick", "Investment Overview", "", selectedTabs(e));
  } else { }
}
export function checkStatus(data){
for (let i=0;i<data.length;i++){
  if(data[i].status === "Active"){
     return true
   }
   
}
return false
}
export default function DashboardTabs(props) { 

  const { tabPanes, tabConfig, styling, containerHeight, transactionClicked } = props;
  return (
    <DashboardTab
      type="card"
      defaultActiveKey="1"
      className={`primary ${styling} `}
      onTabClick={tabsHandler}
      data-test="dashboardTabs"
    >
      {/* Tab One  */}
      {tabPanes[0].isLoading === false ? (
        tabPanes[0].data.length !== 0 ? (
          <TabPane
            tab={`${tabPanes[0].title}`}
            key={1}
          >
            <TabContainer
              height={containerHeight}
              yscroll={true}
              xscroll={false}
            >
              <TabPanes
                clicked={transactionClicked}                
                itemData={tabPanes[0].data}
                tabIndex={0}
                tabConfig={tabConfig}
                filters={tabPanes[0].options}
                destComponent={tabPanes[0].destComponent}
                mobComponent={tabPanes[0].mobComponent}
                columnConfig={tabPanes[0].columnConfig}
                expandConfig={tabPanes[0].expandConfig}
              />
              <WhiteGradient
                className={
                  containerHeight === "initial"
                    ? "display-none"
                    : "display-block"
                }
              />
            </TabContainer>
          </TabPane>
        ) : (
            <TabPane
              tab={`${tabPanes[0].title}`}
              key={1}
            >
              <TabContainer
                height={containerHeight}
                yscroll={true}
                xscroll={false}
                className="no-data"
              >
                <TabPanes
                  clicked={transactionClicked}                  
                  itemData={tabPanes[0].data}
                  tabIndex={0}
                  tabConfig={tabConfig}
                  filters={tabPanes[0].options}
                  destComponent={tabPanes[0].destComponent}
                  mobComponent={tabPanes[0].mobComponent}
                  columnConfig={tabPanes[0].columnConfig}
                  expandConfig={tabPanes[0].expandConfig}
                />
                <NoData>
                  No recent exchanges have been made in the last 90 days.
                </NoData>
                <WhiteGradient
                  className={
                    containerHeight === "initial"
                      ? "display-none"
                      : "display-block"
                  }
                />
              </TabContainer>
            </TabPane>
          )
      ) : (
          <TabPane tab={`${tabPanes[0].title}`} key={1}>
            <TabContainer
              height={containerHeight}
              yscroll={true}
              xscroll={false}
              className="no-data"
            >              
              <Preloader />
              <WhiteGradient
                className={
                  containerHeight === "initial" ? "display-none" : "display-block"
                }
              />
            </TabContainer>
          </TabPane>
        )}

      {/* Tab Two  */}
      {tabPanes[1].isLoading === false ? (
        tabPanes[1].data.length !== 0 && checkStatus(tabPanes[1].data) && (
          
          <TabPane
            tab={`${tabPanes[1].title}`}
            key={2}
          >
            <TabContainer
              height={containerHeight}
              yscroll={true}
              xscroll={false}
            >
              <TabPanes
                clicked={transactionClicked}                
                itemData={tabPanes[1].data}
                tabIndex={1}
                tabConfig={tabConfig}
                filters={tabPanes[1].options}
                destComponent={tabPanes[1].destComponent}
                mobComponent={tabPanes[1].mobComponent}
                columnConfig={tabPanes[1].columnConfig}
                expandConfig={tabPanes[1].expandConfig}
              />              
              <WhiteGradient
                className={
                  containerHeight === "initial"
                    ? "display-none"
                    : "display-block"
                }
              />
            </TabContainer>
          </TabPane>
        ) 
      ) : (
          <TabPane tab={`${tabPanes[1].title}`} key={2}>
            <TabContainer height={containerHeight} yscroll={true} xscroll={false}>
              <Preloader />
              <WhiteGradient
                className={
                  containerHeight === "initial" ? "display-none" : "display-block"
                }
              />
            </TabContainer>
          </TabPane>
        )}
    </DashboardTab>
  );
}
DashboardTab.propTypes = {
  tabPanes: PropTypes.arrayOf(
    PropTypes.shape({
      isLoading: PropTypes.bool,
      data: PropTypes.array,
      title: PropTypes.string,
      destComponent: PropTypes.string,
      mobComponent: PropTypes.string      
    })
  ),
  tabConfig: PropTypes.func,
  containerHeight: PropTypes.string,
  transactionClicked: PropTypes.func
}
